// Write your JS code here
import './index.css'
import Header from '../Header'
import LogoutButton from '../LogoutButton'

const About = () => (
  <div className="about-container">
    <Header />
    <h1>About Route</h1>
    <LogoutButton />
  </div>
)

export default About
